/**
 * Common JS controller.
 *
 * Use this class to run scripts globally and to provide
 * modular helper functions for other scripts classes.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

// Vue
import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use( Vuetify );
Vue.config.productionTip = false;

/**
 * Class Common
 */
export default class Common {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

        // Popup state.
        this.popupState = false;

        // Popup timeout.
        this.popupTimeout = null;

        // Popup category selection
        this.popupCategorySelection = null;

    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.tabElements = $( '.tabbed-content' );

        // The accessible outline style container.
        this.focusStyleContainer = document.getElementById( 'accessible-outline' );

        // Image container
        this.objectfitContainers = $( '.js-object-fit-image-container' );

        // Popup
        this.popup = $( '#js-popup' );

        // Modal popup
        this.modalPopup = $( '#js-popup-modal' );

        // Popup toolbar
        this.popupToolbar = $( '#js-popup-toolbar' );

        // Popup content block
        this.popupContent = $( '#js-popup-content' );

        // Video container
        this.videocontainer = document.getElementsByClassName( 'component-videoblock' );
        this.videocontainerId = $( '#video-container' );

        // Gallery container
        this.galleries = $( '.js-image-gallery' );

        // Back to top -buttons
        this.backToTopFixed = $( '.js-back-to-top-fixed' );

        // Call menu
        this.callMenuArea = $( '.call-menu' );
        this.callMenuButton = $( '.open-call-menu' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {
        const self = this;

        // Add the outline nullifying style to the
        // container in the document head when using the mouse.
        document.body.addEventListener( 'mousedown', e => {
            if ( this.focusStyleContainer ) {
                this.focusStyleContainer.innerHTML = '*:focus{outline:none}';
            }
        } );

        // Remove the outline nullifying style from the
        // container in the document head when using the keyboard.
        document.body.addEventListener( 'keydown', e => {
            if ( this.focusStyleContainer ) {
                this.focusStyleContainer.innerHTML = '';
            }
        } );

        // Bind click event to popup toolbar.
        if( this.popupToolbar.length ) {
            this.popupToolbar.bind( 'click', () => {
                this.popupState = ! this.popupState;

                this.togglePopup();
            } );
        }

        window.onresize = function () {
            self.togglePopup();
        };

        // Save popup category selection
        this.popup.find( '.gfield_radio input[type=radio]' ).bind( 'click', e => {
            this.popupCategorySelection = e.target.value;
        } );

        $( document ).bind( 'gform_confirmation_loaded', ( event, formId, popupSelection ) => {
            this.popupCallRequestSuccess( event, formId, this.popupCategorySelection );
        } );
    }

    /**
     * Fallback for object fit.
     */
    objectFitFallback() {

        // IE and Edge CSS Object fit fallback javascript
        if ( ! Modernizr.objectfit && this.objectfitContainers.length > 0 ) {

            // Loop through object fit containers.
            this.objectfitContainers.each( function () {

                // Variables
                let $container = $( this );
                let imgUrl = $container.find( 'img' ).prop( 'src' );

                if ( imgUrl ) {
                    $container
                        .css( 'background-image', 'url(' + imgUrl + ')' )
                        .addClass( 'compat-object-fit' );
                }
            } );
        } // End if().
    }

    /**
     * Try to send datalayer push event after popup event is successful.
     * We have three different values and depending of the choice, different
     * gaEvent will be sent.
     *
     * @param {object} event            Event object.
     * @param {int}    formId           The ID of the form submitted.
     * @param {string} popupSelection   Popup cateqgory selection.
     */
    popupCallRequestSuccess( event, formId, popupSelection ) {

        let selectedCategory;

        switch ( popupSelection ) {
            case 'Katot':
                selectedCategory = window.Theme.DataLayer.gaEvents.callRequestRoof;
                break;
            case 'Rännit':
                selectedCategory = window.Theme.DataLayer.gaEvents.callRequestLaunder;
                break;
            case 'Kattoturvatuotteet':
                selectedCategory = window.Theme.DataLayer.gaEvents.callRequestRoofProducts;
                break;
            default:
                selectedCategory = null;
                break;
        }

        // Datalayer push depending on popup category selection
        if ( selectedCategory ) {
            try {
                dataLayer.push( selectedCategory );
            } catch ( e ) {
                console.log( 'Could not find push event data.', e );
            }
        }
    }

    /**
     * Toggle popup.
     */
    togglePopup() {

        const toolbarIcon = $( '#js-popup-toolbar-icon' );
        const toolbarText = $( '#js-popup-toolbar-text' );

        // If popup is clicked manually, don't show it again after 15 seconds.
        if ( ! sessionStorage.getItem( 'popup' ) && this.popupTimeout ) {
            sessionStorage.setItem( 'popup', true );
            clearTimeout( this.popupTimeout );
        }

        // Toggle popup
        if ( ! this.popupState ) {
            this.popup.removeClass( 'popup-active' );
            this.popup.css( 'bottom', '-' + this.popupContent.outerHeight() + 'px' );

            // Hide icon and show text
            toolbarIcon.hide();
            toolbarText.show();
        } else {
            this.popup.addClass( 'popup-active' );
            this.popup.css( 'bottom', 0 );

            // Hide text and show close icon
            toolbarText.hide();
            toolbarIcon.show();
        }

    }

    /**
     * Show popup after 15 seconds if sessionStorage is empty.
     */
    checkPopup() {

        if ( ! sessionStorage.getItem( 'popup' ) ) {
            this.popupTimeout = setTimeout( () => {
                if ( ! this.popupState ) {
                    this.popupState = true;
                    this.togglePopup();
                    sessionStorage.setItem( 'popup', true );
                }
            }, 15000 );
        }

    }

    /**
     * Loop through videocontainer and add click event listener.
     */
    video() {
        const $videoelement = this.videocontainer;

        if ( $videoelement.length > 0 ) {
            for ( let i = 0; i < $videoelement.length; i++ ) {
                $videoelement[ i ].addEventListener( 'click', this.playVideo );
            }
        }
    };

    /**
     * Create iFrame and add it to videocontainer.
     */
    playVideo() {
        const windowHeight = this.offsetHeight + 'px';
        const video = JSON.parse( this.dataset.video );

        this.innerHTML = video.url;

        $( 'iframe' ).each( function () {
            this.style.height = windowHeight;
        } );
    };

    /**
     * Init all found galleries.
     */
    initGalleries() {

        // This inits all found galleries with the lightGallery JS plugin.
        if ( this.galleries.length > 0 ) {
            this.galleries.lightGallery();
        }

    }


    /**
     *
     * Check when the video enters the screen, return true when its in viewport
     *
     * @param {jQuery element} el the current element
     */
    inPicture( el ) {

        var elementTop = $( el ).offset().top;
        var elementBottom = elementTop + $( el ).outerHeight();

        var viewportTop = $( window ).scrollTop();
        var viewportBottom = viewportTop + $( window ).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    /**
     * Autoplay a youtube video when it enters the viewport
     * (viewport check handled with inPicture function)
     */
    checkWhenInViewport() {

        // Bind the autoplay function to resize / scroll
        $( window ).on( 'resize scroll', () => {
            // Go through each video container
            if( this.videocontainerId.length > 0 ) {
                this.videocontainerId.each( ( e, item ) => {

                    // Get the video containers loaded attribute
                    let alreadyLoaded = $( item ).attr( 'loaded' );

                    // If the video is supposed to be on autoplay && its in viewport and its NOT loaded, play it
                    if ( $( item ).data( 'autoplay' ) == true && this.inPicture( item ) == true && alreadyLoaded == 'false' ) {

                        const windowHeight = item.offsetHeight + 'px';
                        const video = JSON.parse( item.dataset.video );

                        // A small tieout, otherwise it wont autoplay
                        setTimeout( () => {
                            item.innerHTML = video.url;

                            $( 'iframe' ).each( function () {
                                this.style.height = windowHeight;
                            } );

                            $( item ).attr( 'loaded', 'true' );

                        }, 1000 );

                    }
                } );
            }
        } );
    }

    /**
     * Show custom message when sending a Gravity Forms form.
     * Set opacity, disable clicking and change text of the submit button.
     */
    submitForm() {
        if ( ! $( '.gform_button' ).length ) {
            return;
        }

        $( '.gform_button' ).on( 'click', function () {
            $( this ).val( 'Lähetetään' );
            $( this ).css( 'opacity', '0.5' );
            $( this ).off( 'click' );
        } );

    }

    /**
     * Run the toggle call menu function.
     */
    callMenu() {
        if( ! this.callMenuButton.length ) {
            return;
        }

        this.callMenuButton.on( 'click', e => this.toggleCallMenu( e ) );
    }

    /**
     * Toggle the call menu.
     */
    toggleCallMenu( e ) {
        e.preventDefault();

        this.callMenuArea.toggleClass( 'u-hide' );
        this.callMenuButton.toggleClass( 'arrow-up' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();
        this.events();
        this.objectFitFallback();
        this.togglePopup();
        this.checkPopup();
        this.video();
        this.initGalleries();
        this.checkWhenInViewport();
        this.toggleBackToTop();
        this.submitForm();
        this.callMenu();

        if ( this.tabElements.length > 0 ) {
            this.tabElements.each( function ( idx, elem ) {
                new Vue( {
                    el: elem,
                    data() {
                        return {
                            active: null
                        };
                    }
                } );
            } );
        }
    }

    /**
     * Toggles the state of an elements aria-hidden attribute. If the element does not have an aria-hidden attribute,
     * one will be created and set to false.
     *
     * @param {object} elements The nodelist containing the elements
     * @return {void}
     */
    static toggleAriaHidden( element ) {
        const ariaExpandedState = element.getAttribute( 'aria-hidden' ) === 'false' ? true : false;
        element.setAttribute( 'aria-hidden', ariaExpandedState );
    }

    /**
     * Show and hide the fixed back to top -button
     */
    toggleBackToTop() {

        // This is the amount in pixels that user needs to scroll before back to top-button appears
        const distanceFromTop = 750;

        // When the user scrolls down from the top of the document, show the button. Hide it when 1200px from bottom of the page
        $( window ).scroll( () => {
            if ( document.body.scrollTop > distanceFromTop || ( document.documentElement.scrollTop > distanceFromTop && ( window.innerHeight + window.scrollY ) <= document.body.offsetHeight - 1200 ) ) {
                this.backToTopFixed.removeClass( 'currently-hidden' );
            } else {
                this.backToTopFixed.addClass( 'currently-hidden' );
            }

        } );
    }

    /**
     * Removes classname from each element in a nodelist or array of elements.
     *
     * @param {object} elements  The nodelist containing the elements
     * @param {string} className The classlist to remove
     * @return {void}
     */
    static removeClassFromAll( elements, className ) {

        // Return early if missing required attributes.
        if ( ! elements || ! className ) {
            return;
        }

        Array.from( elements ).forEach( element => {
            element.classList.remove( className );
        } );
    }

    /**
     * Set attribute on each element in a nodelist or array of elements.
     *
     * @param {object} elements  The nodelist or array containing the elements
     * @param {string} attribute The attribut to change
     * @param {string} value     The value of the attribute
     * @return {void}
     */
    static setAttrOnAll( elements, attribute, value ) {

        // // Return early if missing required attributes.
        if ( ! elements || ! attribute || ! value ) {
            return;
        }

        Array.from( elements ).forEach( element => {
            element.setAttribute( attribute, value );
        } );
    }

    /**
     * Get all the siblings of an element. Optionally specify a classname to only get the elements with said class.
     *
     * @param {object} element   The element whose sibilings to find.
     * @param {string} classname Optional classname that siblings must match.
     * @return {object}    Returns empty array if no matches are found; otherwise, it returns all matching elements.
     */
    static siblings( element, classname ) {

        // Return empty arry if missing required attributes
        if ( ! element ) {
            return [];
        }

        return Array.prototype.filter.call( element.parentNode.children,
            function ( child ) {
                if ( classname ) {
                    if ( ! child.classList.contains( classname ) ) {
                        return false;
                    }
                }
                return child !== element;
            }
        );
    }

    /**
     * Select a list of matching child elements from an array of elements.
     *
     * @param  {object} elements A nodelist. Use each item in nodelist as context when finding the children.
     * @param  {string} selector The query selector string.
     * @return {object]}   Returns empty array if no matches are found; otherwise, it returns all matching elements.
     */
    static childrenFromEach( elements, selector ) {

        // Return empty array if missing required attributes or elements empty
        if ( ! elements || ! selector || ! elements.length > 0 ) {
            return [];
        }

        const arrayOfNodes = Array.prototype.map.call( elements,
            function ( element ) {

                // Get all matching elements.
                const matchingChildren = ( element ).querySelectorAll( selector );

                // Convert nodelist to array.
                return [ ...matchingChildren ];
            }
        );

        // Flatten the array
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce?v=a
        const flattened = arrayOfNodes.reduce( ( a, b ) => [ ...a, ...b ] );
        return flattened;
    }

    /**
     * Offers safe way to stop a JS event.
     *
     * Example usage:
     * Theme.Common.stop(e);
     *
     * @param e Event object.
     */
    static stop( e ) {
        e.preventDefault ? e.preventDefault() : ( e.returnValue = false );
    }

    /**
     * Select a list of matching elements, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object}          Returns empty nodelist if no matches are found; otherwise, it returns a nodelist of matching elements.
     */
    static $( selector, context ) {
        return ( context || document ).querySelectorAll( selector );
    }

    /**
     * Select the first match only, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object|null}     Returns null if no matches are found; otherwise, it returns the first matching element.
     */
    static $1( selector, context ) {
        return ( context || document ).querySelector( selector );
    }

}
